module.exports = {
    API_URL: 'https://api.balabaqsha.kz/',
    API_VERSION: 'v1',
}